import { render, staticRenderFns } from "./newcoper.vue?vue&type=template&id=682a7b4e&scoped=true"
import script from "./newcoper.vue?vue&type=script&lang=js"
export * from "./newcoper.vue?vue&type=script&lang=js"
import style0 from "./newcoper.vue?vue&type=style&index=0&id=682a7b4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682a7b4e",
  null
  
)

export default component.exports